import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/CatalogsInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/catalogs`;
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
};
//#endregion
export { n as CatalogsInternalResource };

//# sourceMappingURL=CatalogsInternalResource.js.map